import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudPort = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'port/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllPort = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_port_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudPort = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'port/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudPort = (data, id) => {
  let url = privateCloudBaseUrl + 'port/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    needPrivateCloudProjectHeader: true,
    method: method
  })
}

export const deletePrivateCloudPort = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'port/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}
